import { SelectOption } from '@frontend/components/basic-forms';
import { FunctionalityEnumClient } from '@frontend/functionality/api';
import { Application } from '@frontend/functionality/types';
import { useEffect, useState } from 'react';

import { ApplicationSelectProps } from './application-select.component';

interface ViewProps {
    options: SelectOption<Application>[];
}

const useApplicationSelect = (props: ApplicationSelectProps): ViewProps => {
    const [options, setOptions] = useState<SelectOption<Application>[]>([]);

    useEffect(() => {
        const fetchOptions = async () => {
            const apps = await FunctionalityEnumClient.fetchApplications();
            setOptions(apps.map((c) => ({ label: c.replace(/_/g, ' '), value: c })));
        };
        fetchOptions();
    }, []);

    return { options };
};

export default useApplicationSelect;
